<template>
  <div :class="[bannerPic ? 'bg_image' : 'bg_image_web']">
    <img src="../assets/images/logo.png"/>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    name: 'bannerBg',
    computed: mapState([
      'platform'
    ]),

    data () {
      return {
        bannerPic: this.platform === 'LegendHill'
      }
    }

  }
</script>

<style scoped>
  @import '../assets/css/main.css';
  @import '../assets/css/username.css';
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue